import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { FileText, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PlansSubTab } from "./SubTabs/PlanTab";
import ServiceChargesSubTab from "./SubTabs/ServiceChargesTab";

interface PlanTariffProps {
  serviceChargeStates: Record<string, string[]>;
  onServiceChargeChange: (states: Record<string, string[]>) => void;
}

const InfoBanner = () => (
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3">
    <FileText className="w-5 h-5 text-blue-600 mt-0.5" />
    <div>
      <h3 className="font-semibold text-blue-900">Rates & Plans Overview</h3>
      <p className="text-sm text-blue-800 mt-1">
        Review plan-wise consumer distribution and billing statistics. Each plan
        card displays the consumer category, validity period, and key billing
        metrics including total consumers, billed amount, and average bill per
        consumer
      </p>
    </div>
  </div>
);

const UpdateBanner = () => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-center justify-between">
      <div className="flex gap-3">
        <Settings className="w-5 h-5 text-blue-600 mt-0.5" />
        <div>
          <h4 className="font-semibold text-blue-900">
            Need to Update Rates or Plans Details?
          </h4>
          <p className="text-sm text-blue-800 mt-1">
            Navigate to the Rates and Plans section to modify plan configurations,
             rates, or consumer categories before proceeding.
          </p>
        </div>
      </div>
      <Button onClick={() => navigate("/plan-tarrif/plan-tarrif-landing")}>Go to Rates & Plans</Button>
    </div>
  );
};

const PlansAndTariffTab = ({
  serviceChargeStates,
  onServiceChargeChange,
}: PlanTariffProps) => {
  return (
    <div className="space-y-6">
      <InfoBanner />
      <UpdateBanner />

      <Tabs
        defaultValue="plans"
        disableUrlSync
        idPrefix="plans-tariff"
        tabsListClassName="grid grid-cols-2 bg-muted/30 p-1"
        tabComponents={{
          plans: { label: "Plans", component: <PlansSubTab /> },
          "service-charges": {
            label: "Service Charges",
            component: (
              <ServiceChargesSubTab
                value={serviceChargeStates}
                onChange={onServiceChargeChange}
              />
            ),
          },
        }}
      />
    </div>
  );
};

export default PlansAndTariffTab;
